import React from 'react';
import propTypes from 'prop-types';

import eventShape from 'common/PropTypes/eventShape';
import marketShape from 'common/PropTypes/marketShape';
import marketTypeShape from 'common/PropTypes/marketTypeShape';

import SimpleOutcomeComponent from './SimpleOutcomeComponent';

const SimpleOutcomeRowItem = ({ className, event, mainMarket, marketType, suspended }) => (
  <div className={className}>
    <SimpleOutcomeComponent
      className="primary"
      event={event}
      market={mainMarket}
      marketType={marketType}
      suspended={suspended}
    />
  </div>
);

SimpleOutcomeRowItem.propTypes = {
  event: eventShape.isRequired,
  mainMarket: marketShape.isRequired,
  marketType: marketTypeShape.isRequired,
  suspended: propTypes.bool,
};

export default SimpleOutcomeRowItem;
